import store from '../../store'
import { fetchEmailVerificationPrompts } from '../../actions/emailVerification'

// default to 1 minute if not set or invalid
const interval = parseInt(process.env.REACT_APP_EMAIL_VERIFICATION_POLLING_INTERVAL_IN_MS, 10) || 60000

let intervalId = null

function poll() {
  const userId = store.getState().user.id
  if (userId) {
    store.dispatch(fetchEmailVerificationPrompts(userId))
  }
}

export function startEmailVerificationPromptsPolling() {
  if (intervalId) return // already polling

  poll()
  intervalId = setInterval(poll, interval)
}

export function stopEmailVerificationPromptsPolling() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}
